<template>
  <div class="container">

    <el-row>
      <el-form label-position="top" :rules="rules" ref="ruleForm" label-width="80px" inlineMessage status-icon :model="form">
        <el-form-item label="顾客描述" prop="custDescription">
          <el-input type="textarea" v-model="form.custDescription"></el-input>
        </el-form-item>
        <el-form-item label="现象确认" prop="representation">
          <el-input type="textarea" v-model="form.representation"></el-input>
        </el-form-item>
        <el-form-item label="检查内容" prop="checkContent">
          <el-input type="textarea" v-model="form.checkContent"></el-input>
        </el-form-item>
        <el-form-item label="维修方案" prop="repairContent">
          <el-input type="textarea" v-model="form.repairContent"></el-input>
        </el-form-item>
        <el-form-item style="text-align: center">
          <el-button type="info" @click.native="cancels()">取消</el-button>
          <el-button type="primary" @click.native="assignFn">提交</el-button>
        </el-form-item>
      </el-form>
      
    </el-row>
  </div>
</template>
<script>
import { getAlarmCaseAssign } from '@/api/alarmInfo'
import { Toast } from 'mint-ui'
export default {
    data() {
        return {
            form: {},
            rules: {
                custDescription: [
                    { required: true, message: '该项不能为空', trigger: 'change' }
                ],
                representation: [
                    { required: true, message: '该项不能为空', trigger: 'change' }
                ],
                checkContent: [
                    { required: true, message: '该项不能为空', trigger: 'change' }
                ],
                repairContent: [
                    { required: true, message: '该项不能为空', trigger: 'change' }
                ]
            },
        }
    },
    created() {
    },
    methods: {
        assignFn() {
            this.$refs.ruleForm.validate((valid) => {
                if(valid){
                    getAlarmCaseAssign({id: this.$route.params.id, ...this.form}).then(res => {
                        if(res.data.success){
                            Toast({
                                message: res.data.msg,
                                iconClass: 'icon el-icon-check'
                            })
                            this.$router.push({path: '/alarmList'})
                        }else{
                            Toast({
                                message: res.data.msg,
                                iconClass: 'icon el-icon-close'
                            })
                        }
                    })
                }
            })
            
        },
        cancels() {
            this.$router.go(-1)
        },
        onSubmit() {

        }
    }
}
</script>
<style scoped>
  .container {
    max-width: 500px;
    margin: auto;
    padding: 0 0.32rem;
    background: #fff;
  }
  .el-col, .el-col-18 {
    height:0.3rem;
    line-height: 0.4rem;
  }
  .el-col {
    padding: 0 0.1rem;
  }
  .header {
    padding-bottom: 0.15rem;
    border-bottom: 1px solid blue;
  }
  .el-form-item {
    text-align: left;
    margin: 0.1rem 0;
  }
  .el-form-item__label,.el-form-item__content {
    line-height: 0.4rem;
  }
  .el-date-editor.el-input {
    width: 100%;
  }
  .el-input__icon {
    height: auto;
  }
  .el-row {
    margin-bottom: 0.1rem;
  }
  .el-radio{
    margin-right: 3%;
    margin-bottom: 15px;
  }
</style>
